import React from 'react';
import LocationSearch from './LocationSearch';
import { useTranslation } from 'react-i18next';
import searchFilters from '../../model/searchFilters';
import SearchInput from './SearchInput';

const MapSearch = ({
	searchType,
	setSearchType,
	searchQuery,
	setSearchQuery,
	handleGeneralSearch,
	handlePublicDataSearch,
	isLoading = false,
}) => {
	const { t } = useTranslation();
	const searchFiltersTypes = searchFilters();

	return (
		<div className="map-search">
			<div className="has-text-weight-bold is-size-6">
				{t('search_component')}
			</div>
			<div className="map-search-filters">
				{searchFiltersTypes.map((filter) => (
					<label key={filter.key} htmlFor={filter.key}>
						<input
							type="radio"
							id={filter.key}
							value={filter.key}
							name="map-search"
							checked={searchType === filter.key}
							onChange={(e) => {
								setSearchType(e.target.value);
							}}
							style={{ display: 'none' }}
						/>
						<span data-label={t('search_filter.' + filter.key)}>
							{t('search_filter.' + filter.key)}
						</span>
					</label>
				))}
			</div>
			{searchType === 'GENERAL' ? (
				<>
					<LocationSearch onSearch={handleGeneralSearch} />
				</>
			) : (
				<SearchInput
					value={searchQuery}
					onChange={(value) => setSearchQuery(value)}
					placeholder={t('search')}
					onEnter={handlePublicDataSearch}
					onClick={handlePublicDataSearch}
					isLoading={isLoading}
				/>
			)}
		</div>
	);
};

export default MapSearch;
